import { useCallback, useState, useEffect } from 'react';
export default function useActiveSection(_ref) {
  let {
    sections
  } = _ref;
  const {
    0: visibleUpdateKey,
    1: setVisibleUpdateKey
  } = useState('');
  const {
    0: lastActive,
    1: setLastActive
  } = useState(null);
  const {
    0: activeSection,
    1: setActiveSection
  } = useState(null);
  const {
    0: visibleSections,
    1: setVisibleSections
  } = useState([]);
  const onSectionVisibility = useCallback(function (isVisible) {
    let sectionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    setVisibleSections(function () {
      let prevSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      const index = prevSections.indexOf(sectionId); // Add visible section, if not added

      if (isVisible && index === -1) {
        prevSections.push(sectionId);
      } // Remove non-visible section, if present


      if (!isVisible && index > -1) {
        prevSections.splice(index, 1);
      } // Ensure sections order matches source


      const sectionIds = sections.map(_ref2 => {
        let {
          id
        } = _ref2;
        return id;
      });
      const result = prevSections.sort((idA, idB) => sectionIds.indexOf(idA) - sectionIds.indexOf(idB));
      setVisibleUpdateKey(result.join(','));
      return [...result];
    });
  }, [sections]);
  const onSectionSelect = useCallback(sectionId => {
    const scollContainer = document.querySelector('#scroll-container');
    const sectionEl = typeof document !== 'undefined' && document.getElementById(sectionId);

    if (sectionEl && true) {
      window.history.pushState({}, '', `#${sectionId}`);
      scollContainer === null || scollContainer === void 0 ? void 0 : scollContainer.scrollTo({
        top: sectionEl.getBoundingClientRect().top + scollContainer.scrollTop - 10,
        behavior: 'smooth'
      });
    }
  }, []);
  useEffect(() => {
    const activeId = visibleSections[0];
    const result = sections.find(section => section.id === activeId) || lastActive || null;
    setLastActive(result);
    setActiveSection(result);
  }, [lastActive, sections, visibleSections, visibleUpdateKey]);
  return {
    activeSection,
    onSectionSelect,
    onSectionVisibility
  };
}